export default "__VITE_ASSET__ClX$tZYY__"